<template>
  <div class="payment-result-area">
    <div class="payment-result-card">
      <div class="result-icon success">
        <i class="ti ti-circle-check"></i>
      </div>
      <h1>Payment Successful!</h1>
      <p>Your subscription has been activated. You'll receive your access details shortly — check your dashboard for details.</p>

      <div v-if="invoiceId" class="result-meta">
        Invoice: <span>{{ invoiceId }}</span>
      </div>

      <div class="result-actions">
        <RouterLink to="/dashboard" class="btn">
          <span class="border-style">Go to Dashboard</span>
        </RouterLink>
        <RouterLink to="/" class="result-secondary-link">Back to Home</RouterLink>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "PaymentSuccessPage",
  setup() {
    const route = useRoute();
    const invoiceId = computed(() => route.query.invoice_id as string | undefined);
    return { invoiceId };
  },
});
</script>

<style scoped>
.payment-result-area {
  min-height: 100vh;
  background: #0a0102;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
}
.payment-result-card {
  background: #201516;
  border: 1px solid #3a2526;
  border-radius: 20px;
  padding: 3rem 2.5rem;
  max-width: 480px;
  width: 100%;
  text-align: center;
}
.result-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 2.5rem;
}
.result-icon.success {
  background: rgba(25, 135, 84, 0.15);
  color: #4ade80;
}
h1 {
  color: #fff;
  font-size: 1.75rem;
  font-weight: 800;
  margin-bottom: 1rem;
}
p {
  color: #c0c0c0;
  line-height: 1.65;
  margin-bottom: 1.5rem;
}
.result-meta {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid #3a2526;
  border-radius: 8px;
  padding: 0.6rem 1rem;
  font-size: 0.85rem;
  color: #c0c0c0;
  margin-bottom: 1.75rem;
}
.result-meta span {
  color: #fff;
  font-weight: 600;
}
.result-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: center;
}
.result-secondary-link {
  color: #c0c0c0;
  font-size: 0.9rem;
  text-decoration: none;
}
.result-secondary-link:hover { color: #fff; }
</style>
